<template>
	<div class="nse-star-map preview-element" :style="wrapStyle">
		<svg :width="shapeSizePx.w"
			 :height="shapeSizePx.h"
			 :viewBox="viewBox"
			 :id="idSvgMap">
			<defs>
				<clipPath id="shape">
					<path
						id="shapePath"
						:transform="transformSvgClipPath.rect"
						fill="#ff0000" :d="clipPath"/>
				</clipPath>
			</defs>

			<image v-if="backgroundImage"
				   :width="shapeSizePx.width"
				   :height="shapeSizePx.height"
				   :transform="transformSvgClipPath.map"
				   clip-path="url(#shape)"
				   :xlink:href="backgroundImage"></image>
			<rect
				stroke-width="0"
				v-else-if="starMapColor"
				clip-path="url(#shape)"
				:fill="starMapColor"
				:width="starMapSizePx.w"
				:height="starMapSizePx.h"
				:transform="transformSvgClipPath.map"
			></rect>

			<g stroke-width="0"
			   clip-path="url(#shape)"
			   :transform="transformSvgClipPath.map"
			   v-html="starMapSvgOrigin"></g>
		</svg>
	</div>
</template>


<script>
import {computed, ref} from "vue";

export default {
	name: "StarMapPreview",
	props: {
		spec: {
			type: Object,
			default() {
				return {}
			}
		},

		selectedItems: {
			type: Object,
			default() {
				return {}
			}
		},

		dimensions: {
			type: Object,
			default() {
				return {}
			}
		},

		zoomShape:{
			type: Boolean,
			default: true
		},

		clipPath: {
			type: String
		},

		backgroundColor: {
			type: String,
			default: ""
		},

		backgroundImage: {
			type: String,
			default: ""
		},
	},

	setup(props) {
		const testTrans = ref(1);
		const starMapSvgOrigin = computed(() => {
			return window.nse_app.StarMap.value;
		});

		const idSvgMap = computed(() => {
			return window.nse_app.starMapPreviewId
		});

		const starMapSvg = computed(() => {
			var svg = window.nse_app.StarMap.value;
			svg = btoa(unescape(encodeURIComponent(svg)))
			svg = "data:image/svg+xml;base64," + svg;
			return svg;
		});

		const starMapColor = computed(() => {
			return props.selectedItems.star_map_color
                ? props.selectedItems.star_map_color.value : '';
		});

		const specShape = computed(() => {
			var s = props.spec.star_map;
			if (props.spec.star_map_shape && props.spec.star_map_shape.top > 0 
				|| props.selectedItems.poster_style.value === 'mountain') {
				s = props.spec.star_map_shape
			}
			return s;
		});

		// Wrapper
		const wrapStyle = computed(() => {
			return `
			width: ${specShape.value.width}%;
			height: ${specShape.value.height}%;
			top: ${specShape.value.top}%;
			left: ${specShape.value.left}%;
			`;
		});

		const viewBox = computed(() => {
			return `0 0 ${shapeSizePx.value.w} ${shapeSizePx.value.h}`
		});

		// Size Shape and Starmap
		const shapeSizePx = computed(() => {
			var w = window.nse_app.star_map_width_desktop;
			var wOrigin = specShape.value.width * (props.selectedItems.poster_size.poster_width / 100)
			var hOrigin = specShape.value.height * (props.selectedItems.poster_size.poster_height / 100)
			var ratio = wOrigin / hOrigin;
			var h = w / ratio;

			var output = {
				w: w,
				h: h,
				diagonal: Math.sqrt(Math.pow(w, 2) + Math.pow(h, 2))
			}
			return output;
		});

		const starMapSizePx = computed(() => {
			var w = nse_app.star_map_width_mobile;
			return {
				w: w,
				h: w,
				scale: 1,
			}
		});

		const transformShape = computed(() => {
			if (!props.spec.star_map_shape) {
				return 'scale(1 1) translate(0 0)';
			}

			var x = 0;
			var y = 0;
			var scale = 1;

			return `scale(${scale}) translate(${x} ${y})`;
		});

		const transformSvg = computed(() => {
			if (!props.spec.star_map_shape) {
				return 'scale(1 1) translate(0 0)';
			}
			return `scale(1)`;
		});



		const transformSvgClipPath = computed(() => {
			var scale = 1;
			var diagonalShape = shapeSizePx.value.diagonal

			scale = starMapSizePx.value.w / diagonalShape
			var x = 0;
			var y = 0;

			var xm = 0;
			var ym = 0;


			x = starMapSizePx.value.w - (shapeSizePx.value.w * scale);
			x /= 2
			xm = x;
			x /= scale

			y = starMapSizePx.value.h - (shapeSizePx.value.h * scale);
			y /= 2
			ym = y;
			y /= scale

			var diagonalMap = diagonalShape * scale;
			var scaleMap  = diagonalShape / diagonalMap;

			if(!props.zoomShape) {
				x =y=ym=xm=0;
				scaleMap = scale = 1;
			}

			return {
				rect: `scale(${scale}) translate(${x} ${y})`,
				map: `scale(${scaleMap}) translate(-${xm} -${ym})`,
			};
		});

		return {
			starMapSvg,
			wrapStyle,
			viewBox,
			starMapSvgOrigin,

			transformSvg,
			transformShape,
			idSvgMap,
			starMapColor,

			shapeSizePx,
			starMapSizePx,

			testTrans,


			transformSvgClipPath
		}
	}
}
</script>
